export default __webpack_public_path__ + "static/media/ic_arrow-circle-left.da2c2037.svg";